<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-4 h-4"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.67 4.2L3.54 1.04C3.64 0.68 3.88 0.37 4.21 0.19C4.54 0 4.94 -0.05 5.3 0.05L12.27 1.86C12.64 1.96 12.95 2.19 13.14 2.51C13.33 2.84 13.38 3.22 13.28 3.58L12.17 7.63C11.97 8.36 11.21 8.8 10.45 8.63"
      :fill="active ? '#E2E4EE' : '#E2E4EE'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.67 9.87V5.47C10.67 5.08 10.51 4.7 10.22 4.43C9.93 4.15 9.55 4 9.14 4H1.52C1.12 4 0.73 4.15 0.45 4.43C0.16 4.7 0 5.08 0 5.47V9.87C0 10.26 0.16 10.63 0.45 10.9C0.73 11.18 1.12 11.33 1.52 11.33H9.14C9.98 11.33 10.67 10.68 10.67 9.87Z"
      :fill="active ? 'url(#cards_blue)' : 'url(#cards_gray)'"
    />
    <path d="M10.67 6.33V7.33H0V6.33H10.67Z" fill="white" />
    <defs>
      <linearGradient id="cards_blue" x1="0.48" y1="10.42" x2="8.35" y2="3.57" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <linearGradient id="cards_gray" x1="0.48" y1="10.42" x2="8.35" y2="3.57" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  active?: boolean
}>()
</script>
